/*
 * Si la seccion de cobros se le ensena a la gente.
 *
 * La web es publica desde antes de que exista la tienda de pagos. Mientras no
 * este lista, cualquiera que se registre —que es propietario de su propio
 * negocio— veria "Facturacion" y acabaria en una pasarela en modo de pruebas:
 * no le cobraria nada, pero le haria escribir su tarjeta de verdad donde no
 * debe.
 *
 * Esto es solo la mitad visible. Quien escriba /facturacion a mano entra
 * igual, y por eso el servidor tiene su propia puerta —`COBROS_ABIERTOS` en
 * functions/src/lib/config.ts— que es la que de verdad cierra el paso. Esta de
 * aqui evita ensenar un camino que no lleva a ninguna parte; aquella evita que
 * se recorra.
 *
 * Los dos valores hay que cambiarlos a la vez el dia de la apertura. Estan
 * separados porque uno se compila con la pagina y el otro se lee al arrancar
 * las funciones, y no hay forma de que uno lea al otro.
 */
export const COBROS_ABIERTOS = import.meta.env.VITE_COBROS_ABIERTOS === 'true';

/*
 * Los invitados a probar el cobro mientras esta cerrado.
 *
 * Permite recorrer el circuito completo desde una cuenta corriente, viendolo
 * igual que lo vera un cliente. La alternativa —dar superadmin a la cuenta de
 * pruebas— concede permiso sobre todo el proyecto para resolver una sola cosa.
 *
 * Esta lista no es un control de seguridad: viaja en el paquete de la pagina y
 * cualquiera puede leerla. Lo que impide pagar de verdad es la misma lista en
 * el servidor. Aqui solo decide a quien se le ensena el boton.
 */
const INVITADOS = (import.meta.env.VITE_COBROS_PERMITIDOS ?? '')
  .split(',')
  .map((c: string) => c.trim().toLowerCase())
  .filter(Boolean);

export function puedeVerCobros(correo: string | null | undefined, esSuperadmin: boolean): boolean {
  if (COBROS_ABIERTOS || esSuperadmin) return true;
  return correo ? INVITADOS.includes(correo.toLowerCase()) : false;
}
